<template>
  <div>
    <div class="app-container app-container--with-progress">
      <div class="app-container-route">
        <div v-if="membershipType" class="membership-selected">
          {{ membershipType.value }}
          <span />
        </div>

        <HeaderWithIcon title="Verification Complete" />

        <div v-if="isLoggedIn" class="notice notice--success notice--has-icon">
          <p>
            Thank you! Your email has been confirmed. Please <b>continue</b> to
            complete your membership registration.
          </p>
        </div>
        <div v-else class="notice notice--warn">
          <p>
            To complete the verification process please
            <a :href="loginUrl">log in</a>.
          </p>
        </div>

        <div class="actions">
          <button class="btn btn--positive" @click="continueToNextStep">
            {{ isLoggedIn ? "Continue" : "Login" }}
          </button>
        </div>
      </div>
      <div class="app-container-progress">
        <progress-bar />
      </div>
    </div>
  </div>
</template>

<script>
import HeaderWithIcon from "@/components/HeaderWithIcon";
import ProgressBar from "@/components/ProgressBar.vue";
import { doGet } from "@/helpers/fetch-helper";
import { useLoggedInStatus } from "@/helpers/loggedInStatus";
import { useMemberDetails } from "@/helpers/member-details";
import { onMounted, ref } from "@vue/composition-api";

export default {
  name: "Check",
  components: {
    ProgressBar,
    HeaderWithIcon,
  },
  setup(_, ctx) {
    const { isLoggedIn } = useLoggedInStatus(),
      showLogin = ref(false),
      redirectUrl = ref(""),
      verificationStatus = ref(false),
      loginUrl = `/auth/requestsignin?returnurl=${window.location.href}`,
      { membershipType, isVerified } = useMemberDetails();

    const continueToNextStep = () => {
      if (isLoggedIn.value) {
        if (process.env.NODE_ENV === "development")
          redirectUrl.value = "/register/membership/contact-details";

        if (redirectUrl.value === "/profile") {
          window.location.href = redirectUrl.value;
        } else {
          ctx.root.$router.push({ path: redirectUrl.value });
        }
      } else {
        window.location.href = loginUrl;
      }
    };

    onMounted(async () => {
      if (isLoggedIn.value) {
        await doGet("/CheckVerificationStatus").then((data) => {
          verificationStatus.value = data.success;
          isVerified.value = data.success;
          redirectUrl.value = data.redirect_to;
        });
      }
    });

    return {
      isLoggedIn,
      showLogin,
      loginUrl,
      redirectUrl,
      verificationStatus,
      membershipType,
      continueToNextStep,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/global-variables.scss";

.app-container {
  &-route {
    h1 {
      align-items: center;
      display: flex;
      justify-content: space-between;
      line-height: 36px;

      img {
        display: none;

        @media screen and (min-width: $large-tablet) {
          display: block;
        }
      }
    }

    .actions {
      text-align: right;
    }
  }
}
</style>
